var inStockNotifier = function(){   if (prdIsSizable){
      
// check if any of 18k WHITE are in stock and therefore sizable      
 if (atLeast1WGInStock && variant.option1 == '18 karat white gold') {
         if (variant.inventory_quantity > 0){
    $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium"); 
  }
 
  else {
    $('p.in-stock-msg').hide().html(resizableMsg).fadeIn("medium");
      
  }
}
      
      //  check if any of 18k YELLOW gold are in stock and therefore sizable
 
    else if (atLeast1YGInStock && variant.option1 == '18 karat yellow gold') {
    
         if (variant.inventory_quantity > 0){
    $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium");  
  }
 
  else {
    $('p.in-stock-msg').hide().html(resizableMsg).fadeIn("medium");
      
  }
}

      
// check if any of 18k ROSE gold are in stock and therefore sizable
else if (atLeast1RGInStock && variant.option1 == '18 karat rose gold') {
    
          if (variant.inventory_quantity > 0){
    $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium");
  }
 
  else {
    $('p.in-stock-msg').hide().html(resizableMsg).fadeIn("medium");
  }
}

      //check if  Platinum is in stock and sizable
else if (atLeast1PInStock && variant.option1 == 'Platinum') {
    
          if (variant.inventory_quantity > 0){
    $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium");
  }
 
  else {
    $('p.in-stock-msg').hide().html(resizableMsg).fadeIn("medium");
  }
}      
/* Silver Cuffs are not resizable, so an item is either in stock or out of stock
else if ((variant.option1 == '925 Sterling Silver' || variant.option1 == '925 Sterling Silver Yellow' || variant.option1 == '925 Sterling Silver White' || variant.option1 == '925 Sterling Silver Gold Color' || variant.option1 == '925 Sterling Silver Platinum Color' || variant.option1 == '925 Sterling Silver Black Color') && variant.inventory_quantity > 0) 
{
   
   $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium");
}*/
 
// display out of stock message if no variants in stock found
 else {
    $('p.in-stock-msg').hide().html(outOfStockMsg).fadeIn("medium");
  }
      } //end block for sizable products
      
      else {
  if (variant.inventory_quantity > 0){
    $('p.in-stock-msg').hide().html(inStockMsg).fadeIn("medium");}
  else {$('p.in-stock-msg').hide().html(outOfStockMsg).fadeIn("medium");}
}
//end of block IN STOCK NOTIFIER 
      
      
     // alert(variant.inventory_quantity);
      //alert(isAnyVariant);
      
      //STOCK CODE END
      
      // WRITE VARIANT STONE METAFIELED INTO A STONE DIV
      if (metaData[variant.sku] !== null){
        $('div.stone-content').hide().text(metaData[variant.sku]).fadeIn("medium");
        //alert(metaData[variant.sku])
      }      

      
      // WRITE METAL TYPE BASED ON SELECTION
      
      
      
      if (variant.option1 == '18 karat white gold'){
        
       $('div.metal-content').hide().html("18 karat white gold").fadeIn("medium");
}
      else if (variant.option1 == '18 karat rose gold'){
        
       $('div.metal-content').hide().html("18 karat rose gold").fadeIn("medium");
}
            else if (variant.option1 == '18 karat yellow gold'){
        
       $('div.metal-content').hide().html("18 karat yellow gold").fadeIn("medium");
}
            else if (variant.option1 == 'Platinum'){
        
       $('div.metal-content').hide().html("Platinum").fadeIn("medium");
}
            else if (variant.option1 == '925 Sterling Silver White'){
        
       $('div.metal-content').hide().html("925 Sterling Silver White").fadeIn("medium");
}
        else if (variant.option1 == '925 Sterling Silver Yellow'){
        
       $('div.metal-content').hide().html("925 Sterling Silver Yellow").fadeIn("medium");
}
        else if (variant.option1 == '18 karat yellow and white gold'){
        
       $('div.metal-content').hide().html("18 karat yellow and white gold").fadeIn("medium");
}
        else if (variant.option1 == '18 karat rose and white gold'){
        
       $('div.metal-content').hide().html("18 karat rose and white gold").fadeIn("medium");
        }
       else if (variant.option1 == '18 karat white and yellow gold'){
        
       $('div.metal-content').hide().html("18 karat white and yellow gold").fadeIn("medium");
}
        else if (variant.option1 == '18 karat white and rose gold'){
        
       $('div.metal-content').hide().html("18 karat white and rose gold").fadeIn("medium");
        }
      
  
/*IS-CUSTOM-CODE END */
                                 
                                };